import type { ReactElement, ReactNode } from 'react'

interface Props {
  title: ReactNode
  subtitle?: ReactNode
  children?: ReactNode
  imageSrc?: string
}

export default function Hero({ title, subtitle, children, imageSrc }: Props): ReactElement {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="row align-items-center g-5">
          <div className={imageSrc ? 'col-lg-7' : 'col-12 text-center'}>
            <h1 className="hero-title display-4 mb-3">{title}</h1>
            {subtitle && <p className="lead text-muted mb-4">{subtitle}</p>}
            {children && <div className="d-flex flex-wrap gap-3">{children}</div>}
          </div>
          {imageSrc && (
            <div className="col-lg-5 text-center">
              <img src={imageSrc} alt="" className="img-fluid" style={{ maxWidth: 320 }} />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
